import React, { useContext, useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import InputReactSelect from 'modules/common/components/InputReactSelect';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateBarangayProfile,
  getBarangayProfileList,
  updateList,
  id,
  history,
  getSingleBarangayProfile,
  updating,
  getOtherFeeCodesList,
  otherFeeCodesList,
  isOtherFeeCodesLoading,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    barangay_name: '',
    barangay_code: '',
    logo: '',
    signatory_name: '',
    signatory_designation: '',
    signatory_signature: '',
    for_new: 0,
    for_renewal: 0,
    with_barangay_clearance: 0,
    other_fee_codes: [],
  });
  const [isChecked, setIsChecked] = useState(0);

  const validateForm = useFormValidator(formData, {
    barangay_name: 'required',
    logo: 'required',
    signatory_designation: 'required_max_200_char',
    signatory_name: 'required_max_200_char',
    signatory_signature: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      for_new: _.get(formData, 'for_new') ? 1 : 0,
      for_renewal: _.get(formData, 'for_renewal') ? 1 : 0,
      with_barangay_clearance: isChecked,
      other_fee_codes:
        _.get(formData, 'other_fee_codes', [])?.map((item) => item.value) || [],
    };

    updateBarangayProfile(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getBarangayProfileList();
      getSingleBarangayProfile(id);
      history.push(`/bpls/settings/barangay-profile/${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        amount: _.get(updateList, 'amount') || '',
        rate: _.get(updateList, 'rate') || '',
        barangay_name: _.get(updateList, 'barangay_name') || '',
        logo: _.get(updateList, 'logo') || '',
        signatory_designation: _.get(updateList, 'signatory_designation') || '',
        signatory_name: _.get(updateList, 'signatory_name') || '',
        signatory_signature: _.get(updateList, 'signatory_signature') || '',
      };

      const barangayClearance = _.get(updateList, 'other_fee_codes', [])?.map(
        (item) => {
          return {
            label: item,
            value: item,
            code: item,
          };
        }
      );

      const newArgs = { ...args, other_fee_codes: barangayClearance };

      setFormData(_.pick(newArgs, _.keys(c.FORM_DATA)));
      setIsChecked(_.get(args, 'with_barangay_clearance', 0));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e ? e.target.value : '',
    });
  };

  const onChangePhoto = (key) => (value) => {
    const pngFormat = value?.toLowerCase().endsWith('.png');

    if (!pngFormat) {
      Alert.error('Invalid image format');

      setFormData({
        ...formData,
        [key]: _.get(updateList, `${key}`) || '',
      });
      return;
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  useEffect(() => {
    const args = {
      ordinance_revision_id: ordinanceRevisionId || 0,
      type: 'BARANGAY CLEARANCE',
      is_paginated: 0
    };
    getOtherFeeCodesList(args);
  }, []);

  const otherFeeCodesOptions = useMemo(() => {
    if (!otherFeeCodesList || _.isEmpty(otherFeeCodesList)) return [];

    return otherFeeCodesList.map((item) => ({
      label: _.get(item, 'attributes.code'),
      value: _.get(item, 'attributes.code'),
    }));
  }, [otherFeeCodesList]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="barangayClearance"
                name="with_barangay_clearance"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked ? 1 : 0)}
              />
              <label
                style={{ fontSize: '.9rem' }}
                className="custom-control-label mt-2"
                htmlFor="barangayClearance"
              >
                Integrate Barangay Business Clearance
              </label>
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Barangay Name: {validateForm.renderMessage('barangay_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="barangay_name"
              onChange={onChange}
              value={_.get(formData, 'barangay_name') || ''}
              disabled
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Barangay Code:
            </label>
            <input
              className="form-control"
              type="text"
              name="barangay_code"
              onChange={onChange}
              value={_.get(formData, 'barangay_code') || ''}
              disabled
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Signatory Name: {validateForm.renderMessage('signatory_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="signatory_name"
              onChange={onChange}
              value={_.get(formData, 'signatory_name') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Signatory Designation:{' '}
              {validateForm.renderMessage('signatory_designation')}
            </label>
            <input
              className="form-control"
              type="text"
              name="signatory_designation"
              onChange={onChange}
              value={_.get(formData, 'signatory_designation') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="amount" className="full-label mb-1">
              Barangay Fees
            </label>
            <InputReactSelect
              name="other_fee_codes"
              value={formData.other_fee_codes}
              onChange={onChange}
              options={otherFeeCodesOptions}
              isMulti // Enable multi-select
              placeholder="Search and select other fee..."
              additional={{
                closeMenuOnSelect: false, // Keep menu open after selection
                menuPlacement: 'auto',
              }}
              isLoading={isOtherFeeCodesLoading}
            />
          </div>
          <div className="col-6">
            <label className="full-label mb-0">
              Logo {validateForm.renderMessage('logo')}
            </label>
            <div
              className="animated flash text-danger"
              style={{ fontSize: 10, padding: '1px' }}
            >
              (.png type ONLY, Max: 5MB)
            </div>
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'logo') || '')
                  ? _.get(formData, 'logo') || ImagePlaceholder
                  : _.get(formData, 'logo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
            <FilePondSingleUpload onChange={onChangePhoto('logo')} />
          </div>
          <div className="col-6">
            <label className="full-label mb-0">
              Signatory Signature{' '}
              {validateForm.renderMessage('signatory_signature')}
            </label>
            <div
              className="animated flash text-danger"
              style={{ fontSize: 10, padding: '1px' }}
            >
              (.png type ONLY, Max: 5MB)
            </div>
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'signatory_signature') || '')
                  ? _.get(formData, 'signatory_signature') || ImagePlaceholder
                  : _.get(formData, 'signatory_signature.cdnUrl') ||
                    ImagePlaceholder
              }
              alt=""
            />
            <FilePondSingleUpload
              onChange={onChangePhoto('signatory_signature')}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateBarangayProfile: PropTypes.instanceOf(Function).isRequired,
  getBarangayProfileList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleBarangayProfile: PropTypes.instanceOf(Function).isRequired,
  getOtherFeeCodesList: PropTypes.instanceOf(Function).isRequired,
  otherFeeCodesList: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
  isOtherFeeCodesLoading: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_BARANGAY_PROFILE) > -1,
  otherFeeCodesList: _.get(api, `${c.GET_OTHER_FEE_CODES_LIST}.list`) || [],
  isOtherFeeCodesLoading: api.loading.indexOf(c.GET_OTHER_FEE_CODES_LIST) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);

// Rename other fee codes = Barangay Fees
// Other fees > set fee type to common fee and lock it (greyed out)
// Brgy. clerance type > do not show retirement checkbox
